var _style, _defs, _path, _path2, _path3, _path4, _text, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRegisteredColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8192 2832",
    style: {
      enableBackground: "new 0 0 8192 2832"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000000942956530681715980000014964517141011429045_);}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:url(#SVGID_00000011020511020486823720000015491934845976822699_);}\n\t.st3{font-family:'Montserrat-Medium';}\n\t.st4{font-size:163.3343px;}\n\t.st5{fill:none;stroke:#E6E6E6;stroke-width:10;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.1,
    y: 461.4,
    width: 8191.9,
    height: 1909.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077309779382373210490000002783907755073768838_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000077309779382373210490000002783907755073768838_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2426.7,1657.9c115.5,0,186.1-57.7,186.1-150.7c0-87-67.2-116.3-170.5-138.6c-68.8-14.6-91.3-24.1-91.3-52.6 c0-23.3,20.7-40.5,57.7-40.5c43.1,0,89.6,16.4,132.7,49.1l58.5-82.6c-49.1-40.5-110.3-62.9-187.8-62.9 c-106,0-177.4,59.5-177.4,148.1s74.1,119.7,173,142.1c67.2,16.4,88.8,22.4,88.8,50c0,24.9-22.4,42.1-65.5,42.1 c-56.8,0-106.8-21.6-152.5-58.5l-64.6,77.5C2269.9,1631.2,2344.8,1657.9,2426.7,1657.9z M2716,1650.2h115.5v-144.7h99.9 c101.7,0,175.7-65.5,175.7-159.4s-74.1-159.4-175.7-159.4h-215.3V1650L2716,1650.2L2716,1650.2z M2831.5,1400.4v-108.5h88.8 c40.5,0,68,21.6,68,54.2c0,32.7-27.5,54.2-68,54.2h-88.8V1400.4z M3531.6,1650.2h130.1l-183.5-463.3h-130.1l-182.6,463.3h129.2 l26.7-67.2h183.5L3531.6,1650.2z M3357.6,1492.6l56-142.1l55.1,142.1H3357.6z M3979.5,1657.9c72.3,0,137.8-31,184.3-80.1 l-83.5-74.1c-24.9,30.1-61.1,50-100.8,50c-70.6,0-130.9-62-130.9-135.2c0-73.2,60.3-135.2,130.9-135.2c38.8,0,75.8,19.8,99.9,50 l84.4-75c-46.5-48.2-111.9-79.3-184.3-79.3c-135.2,0-249,109.3-249,239.5C3730.6,1548.5,3844.3,1657.9,3979.5,1657.9z  M4624.6,1290.1v-103.3h-364.3v103.4L4624.6,1290.1L4624.6,1290.1z M4260.4,1362.5v287.7h364.3v-103.3h-249.8v-81.8h226.6v-102.5 H4260.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5167.1,1653.8h74.1l-197.5-462.5h-75.8l-199.2,462.5h75.8l41.1-93.8h240.3l41.1,93.8H5167.1z M4912,1497.5 l93.8-219l93.8,219L4912,1497.5L4912,1497.5z M5358,1653.8h69.1v-350.5l265,350.5h69.1v-462.5h-69.1v350.5l-265-350.5H5358 V1653.8z M5917.6,1653.8h159.7c149.7,0,256.8-97.1,256.8-232s-107.1-230.4-256.8-230.4h-159.7V1653.8z M5986.7,1591.3v-339.1 h95.5c107.1,0,181,70.7,181,169.5s-74.1,169.5-181,169.5H5986.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6602.8,1652.8h115.5v-359.1h140.4v-103.4h-396.3v103.4h140.4L6602.8,1652.8L6602.8,1652.8z M6961.1,1652.8 h115.4v-462.5h-115.4V1652.8z M7204.9,1652.8h115.4v-267.9l133.5,241.2l133.5-241.2v267.9h115.4v-462.5h-115.4l-133.5,241.2 l-133.5-241.2h-115.4V1652.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7830.1,1365.1v287.7h364.3v-102.5h-249.8v-81.8h226.6v-103.3L7830.1,1365.1L7830.1,1365.1z M8194.4,1293.6 v-103.4h-364.3v103.3L8194.4,1293.6L8194.4,1293.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173862461569675658690000007720404291085512357_",
    cx: 5167.5103,
    cy: -4.2883,
    r: 10.0429,
    gradientTransform: "matrix(197.2151 -118.4922 123.2289 205.0987 -1018593.9375 615072.625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5000BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#6900C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#9700C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#BC00CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#D900D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#EE00D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#FA00D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF00D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FB26E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#F55DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#F373FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#EABFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#99CCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173862461569675658690000007720404291085512357_)"
    },
    d: "M1646.3,1433.9l-1212.2,700 c-6.1,3.5-13.5,3.5-19.5,0l-84.3-48.8c-3.4-2-5.5-5.5-5.5-9.5c0-4,2-7.6,5.5-9.5L931,1719c2.3-1.2,5.1-1.6,7.4-0.4 c2.4,1.2,4.1,3.2,4.7,5.9c3.6,17.9,6.9,36,9.6,54.2c0.2,1.5,1.2,2.8,2.6,3.6c1.3,0.7,3,0.6,4.4-0.2l676-390.4c5.3-3,11.7-3,17,0 c5.2,3,8.5,8.7,8.5,14.8v1.4C1661.2,1418.6,1655.5,1428.5,1646.3,1433.9z M1652.8,1625.8c-5.3-3-11.7-3-17,0l-668.4,386 c-1.5,0.9-3.4,0.9-4.9-0.1c-1.6-1-2.3-2.6-2.2-4.4c1.6-20.6,2.7-41.6,3.1-62.7h-0.2c0-2.2-1.1-4-2.8-5.1c-1.8-1.1-4-1.1-5.9,0 l-422,243.7c-3.4,2-5.5,5.5-5.5,9.5c0,4,2,7.5,5.5,9.5l84.3,48.8c5.9,3.5,13.4,3.5,19.5,0l1009.8-583.3 c9.2-5.3,14.9-15.2,14.9-25.9v-1.4c0-6.1-3.2-11.7-8.5-14.8L1652.8,1625.8z M1652.2,1860.6c-5.5-3.2-12.3-3.2-17.9,0L908,2280 c-1.8,1-3.8,0.8-5.5-0.4s-2-3.4-1.3-5.3c9.6-25.9,18.1-52.4,25.7-79.4c0.3-1.1-0.1-2.1-1-2.8c-0.9-0.6-2-0.7-3-0.2l-188.1,108.7 c-3.4,2-5.5,5.5-5.5,9.4s2,7.6,5.5,9.5l84.3,48.8c5.9,3.5,13.4,3.5,19.5,0l807.3-466.3c9.2-5.3,14.9-15.2,14.9-25.9 c0-6.3-3.4-12.3-9-15.4h0.1L1652.2,1860.6z M8.2,977.1l835.2-482.4c5.5-3.1,8.7-9,8.5-15.2s-3.7-11.9-9.3-14.8 c-9-4.5-19.8-4.3-28.4,0.7L8.2,930.9c-4.9,2.8-8.1,8.2-8.1,13.9v27.6c0,1.9,1,3.6,2.7,4.7C4.5,978.1,6.5,978.1,8.2,977.1 L8.2,977.1z M305.2,987.1c-26.3-9.6-53.2-17.9-80.5-25.3c-2.6-0.7-5.5-0.4-7.8,1L8.4,1083.2c-4.9,2.8-8.1,8.2-8.1,13.9v109.3 c0,1.9,1,3.6,2.7,4.7s3.6,1,5.3,0l1039.3-600.1c5.3-3,8.5-8.8,8.5-14.8c0-6-3.2-11.7-8.5-14.8l-1.2-0.7c-9.2-5.3-20.6-5.3-29.9,0 L313.9,986.3c-2.6,1.5-5.9,1.8-8.6,0.7L305.2,987.1L305.2,987.1z M518.7,1095.2c-18.3-12.2-36.9-23.7-56-34.7 c-3.2-1.8-7.1-1.8-10.3,0L8.2,1317c-4.9,2.8-8.1,8.2-8.1,13.9v109.3c0,1.9,1,3.6,2.7,4.7c1.7,1,3.6,1,5.3,0L1247.5,729 c5.3-3,8.5-8.7,8.5-14.8c0-6.1-3.2-11.7-8.5-14.8l-1.2-0.7c-9.2-5.3-20.6-5.3-29.9,0l-686.9,396.7c-3.4,2-7.6,1.8-10.8-0.4 L518.7,1095.2z M1514.8,729.7c-123.8,0-248.3,73.9-298.8,202.9l-521,300.8c-4.1,2.3-9.2,1.6-12.5-1.8 c-13-13.4-26.3-26.5-40.1-39.2c-3.3-3-8.2-3.6-12.1-1.3L8.2,1550.6c-4.9,2.8-8.1,8.2-8.1,13.9v109.3c0,1.9,1,3.6,2.7,4.7 s3.6,1,5.3,0l1459.1-842.6c5.1-3,11.4-3,16.3,0l73.3,42.3c2.1,1.2,3.5,3.5,3.5,5.9c0,2.5-1.3,4.7-3.5,5.9l-356.1,205.7 c-2,1.1-3,3.3-2.7,5.5c3.4,21.1,8.9,41.5,16.1,61c0.9,2.5,0,5.3-2.4,6.7l-395.2,228.3c-2,1.1-4.5,0.5-5.9-1.4 c-9.8-15.6-20.2-31.1-30.9-46.2c-3-4.3-8.9-5.5-13.5-3L8.2,1784.5c-4.9,2.8-8.1,8.2-8.1,13.9v83.5c0,8,4.3,15.3,11.2,19.3 c4.9,2.8,11.1,2.8,16,0l1623.3-937.6c2.1-1.2,4.7-1.2,6.9,0c2.1,1.2,3.5,3.5,3.5,5.9v84c0.1,5.9-3,11.5-8.2,14.4l-360,208.4 c-0.9,0.4-1.4,1.3-1.5,2.4c-0.1,1,0.2,2,1,2.7c14.7,14.2,30.7,26.9,47.9,38.1c1.6,1,2.5,2.8,2.4,4.7c0,1.9-1.1,3.6-2.7,4.5 l-432.9,250c-1.2,0.7-2.7,0.9-4,0.4c-1.3-0.5-2.3-1.5-2.8-2.8c-6.3-16.7-12.9-33.1-20-49.3c-1.1-2.5-3.2-4.4-5.9-5.3 c-2.6-0.9-5.5-0.5-7.8,0.8l-738.2,426.2c-3.6,2-5.7,5.9-5.7,10c0,4.1,2.2,8,5.7,10l83.5,48.2c5.9,3.5,13.4,3.5,19.5,0 l1419.6-819.7c2.1-1.2,4.7-1.2,6.9,0c2.2,1.2,3.5,3.5,3.5,6v82.6c0.1,5.9-3,11.5-8.2,14.4l-113.8,65.7c-0.4,0.3-0.7,0.9-0.5,1.4 s0.7,0.9,1.2,0.9c43.5-3.2,84.6-15.1,121.5-34c102.9-53.3,173-160.7,173-284.5h0.1C1834.8,872.9,1691.5,729.7,1514.8,729.7 L1514.8,729.7L1514.8,729.7z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1886.4169 716.3345)",
    className: "st1 st3 st4"
  }, "R")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1946,
    cy: 657.6,
    r: 90.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRegisteredColor);
export default __webpack_public_path__ + "static/media/logo_registered_color.7ee7a96ff843cefdecf2b2b49a8f0c89.svg";
export { ForwardRef as ReactComponent };